module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "查看买断时间",
      "width": "450"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 100
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "label": "买断时间"
    }
  }, [_c('Checkbox-group', {
    model: {
      value: (_vm.openedTimeIdList),
      callback: function($$v) {
        _vm.openedTimeIdList = $$v
      },
      expression: "openedTimeIdList"
    }
  }, _vm._l((_vm.openedTimeList), function(item) {
    return _c('Checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_c('span', [_vm._v(_vm._s(item.weekStr) + " " + _vm._s(item.startTimeStr) + " - " + _vm._s(item.endTimeStr))])])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02a79554","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchCancelOpenedTimeModal.vue
// module id = 1593
// module chunks = 8